import {KpiRangeBreachSeverity} from './kpiPerformance.types'
import {ProcessStage} from './shiftHandover.types'

export enum KpiVisibilityFlag {
  PlantPerformancePage = 'plantPerformancePage',
  ReliabilityEngineerEntryPoint = 'reliabilityEngineerEntryPoint',
  ProcessEngineerEntryPoint = 'processEngineerEntryPoint',
  OptimizationSpecialistEntryPoint = 'optimizationSpecialistEntryPoint',
  ShiftSummaryPerformancePage = 'shiftSummaryPerformancePage'
}

export enum Frequency {
  Daily = 'daily',
  Weekly = 'weekly',
  Monthly = 'monthly',
  Yearly = 'yearly'
}

export enum ThresholdsName {
  HighHigh = 'highHigh',
  High = 'high',
  Low = 'low',
  LowLow = 'lowLow'
}

export enum AggregationType {
  Average = 'average',
  WeightAverage = 'weightAverage',
  Max = 'max',
  Min = 'min',
  Sum = 'sum',
  AlternativeFuelRateLogic = 'alternativeFuelRateLogic'
}

type KpiThreshold = {
  value: number
  severity?: KpiRangeBreachSeverity
}

export type Thresholds = Record<ThresholdsName, KpiThreshold>

export type Kpi = Partial<Thresholds> & {
  kpiDefinitionId: number
  formula: string | null
  tagname: string
  displayName: string
  unit: string | null
  frequency?: Frequency
  kpiVisibilityFlags: KpiVisibilityFlag[]
  kpiAssignment: {
    id: number
    aggregationType: AggregationType
    weightAssignmentId: string
  }
}

export type KpiWithValue = {
  definition: Kpi
  lastResult?: LastResult
}

export type KpiProcessStage = {
  definitionsWithResults: KpiWithValue[]
} & ProcessStage

export type LastResult = {
  value: number | string
  startTime: string
  endTime: string
}

export type KpiResponse = {
  processStages: KpiProcessStage[]
}
